export function round(value: number): number {
  // + 0 handles cases for negative 0
  return Math.round(value) + 0;
}
